import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { DateField } from '../../../store/models/field-models';
import { extractFieldErrorMessages } from '../utils';
import { ValidationRuleType } from '../../../store/models/validator-models';
import { FieldUtilsService } from '../field-utils.service';

const FALLBACK_DATE_FORMAT = 'yyyy/MM/dd';

@Component({
    selector: 'app-date-field',
    templateUrl: './date-picker-field.component.html',
    styleUrls: ['./date-picker-field.component.scss'],
})
export class DatePickerFieldComponent {
    @Input() field: DateField;
    @Input() control: FormControl;
    @Input() fieldId: string;

    fallbackDateFormat = FALLBACK_DATE_FORMAT;
    constructor(private store: Store, private translate: TranslateService, public fieldUtils: FieldUtilsService) {}

    get isVisible(): boolean {
        return this.field?.visible !== false;
    }

    get isRequired(): boolean {
        return this.field?.validators?.some((v) => v.type === ValidationRuleType.Required) || false;
    }

    get hasError(): boolean {
        return this.control?.invalid && (this.control?.touched || this.control?.dirty);
    }

    get errorMessages(): string[] {
        return extractFieldErrorMessages(this.control, this.field, this.translate);
    }

    dateInput(event: InputEvent): void {
        const target = event.target as HTMLInputElement;
        const value = target.value;

        this.updateControlValue(value);

        if (this.field.events?.onInput) {
            this.field.events.onInput.call(this.field, value).forEach((action) => this.store.dispatch(action));
        }
    }

    dateChange(event: Event): void {
        const target = event.target as HTMLInputElement;
        const value = target.value;

        this.updateControlValue(value);

        if (this.field.events?.onChange) {
            this.field.events.onChange.call(this.field, value).forEach((action) => this.store.dispatch(action));
        }
    }

    private updateControlValue(value: string): void {
        if (!value || value.trim() === '') {
            this.control.setValue(null, { emitEvent: true });
            return;
        }

        const parsedDate = this.parseDate(value);
        if (parsedDate) {
            this.control.setValue(parsedDate, { emitEvent: true });
        }
    }

    private parseDate(value: string): Date | null {
        if (!value || value.trim() === '') {
            return null;
        }

        const date = new Date(value);
        return isNaN(date.getTime()) ? null : date;
    }
}
